import axios from "axios";

import router from "@/router";

const service = axios.create({
    timeout: 16000,
    // baseURL: process.env.VUE_APP_API_ROOT,
    // baseURL:'/',
    // headers: {'Content-Type': 'application/json'}
})

function customPaymentError(response, fallback, config = {}) {
    const body = response && response.data
    const error = new Error((body && body.message) || fallback || '请求失败，请稍后重试')
    error.status = response && response.status !== 200 ? response.status : (body && body.code)
    error.authScope = config.authScope || 'pc'
    if (Number(error.status) === 401) {
        if (error.authScope === 'phone') {
            localStorage.removeItem('accessKeyPhone')
        } else {
            localStorage.removeItem('accessKey')
            localStorage.removeItem('customPaymentUserInfo')
        }
    }
    return error
}

service.interceptors.request.use(config => {

        config.headers = config.headers || {}
        const hasAuthorization = Object.keys(config.headers).some(name => name.toLowerCase() === 'authorization')
        if (hasAuthorization || config.customPayment) {
            return config
        }

        let  Reg= RegExp('phone')
        if (Reg.test(location.href)){
            if (localStorage.getItem('accessKeyPhone')){
                config.headers.Authorization = 'Bearer ' + localStorage.getItem('accessKeyPhone')
                config.headers['Content-Type'] = 'application/json';
            }
        }else{
            if (localStorage.getItem('accessKey')){
                config.headers.Authorization = 'Bearer ' + localStorage.getItem('accessKey')
                config.headers['Content-Type'] = 'application/json';
            }
        }

        return config
    }, error => {
        Promise.reject(error)
    }
)

service.interceptors.response.use(
    response=>{

        if (response.config && response.config.customPayment) {
            if (response.data.code === 200 && response.status === 200) {
                return response.data
            }
            return Promise.reject(customPaymentError(response, null, response.config))
        }

        if (response.data.code ===200 && response.status===200){
            return response.data
        }
        if (response.data.code===401 || response.status===401){
            if (localStorage.getItem('accessKey')){
                localStorage.removeItem('accessKey')
                router.push('/').catch(err=>{})
            }
            return  Promise.resolve(response)
        }
        if (response.data.code===500 || response.status===500){

            return  Promise.resolve(response)
        }
        if (response.data.code===405 || response.status===405){

            return  Promise.resolve(response)
        }

        return Promise.resolve(response);
    },
    error => {

        if (error.config && error.config.customPayment) {
            return Promise.reject(customPaymentError(error.response, error.message, error.config))
        }
        return Promise.reject(error)
    })


export default service
